import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lang: window.location.pathname.split('/')[3],
  profileUpdateScreen: false,
  session: null,
  sessionError: null,
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    changLang: (state, action) => {
      state.lang = action.payload
    },
    setProfileUpdateScreen: (state, action) => {
      state.profileUpdateScreen = action.payload
    },
  },
})

export const { changLang, setProfileUpdateScreen } = globalSlice.actions

export default globalSlice.reducer
